import { makeStyles } from "@material-ui/core";

const MuiStylesAppointmentDialog = makeStyles((theme) => ({
  dialogPaper: {
    borderRadius: "16px",
    maxWidth: "600px",
    margin: "16px",
    maxHeight: "90vh",
    overflow: "hidden",
  },
  dialogHeader: {
    padding: "20px 24px 16px",
    backgroundColor: "#f8f9fa",
    borderBottom: "1px solid #e9ecef",
  },
  headerContent: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  dialogTitle: {
    fontSize: "20px",
    fontWeight: "600",
    color: "#2c3e50",
    margin: 0,
  },
  closeButton: {
    minWidth: "auto",
    padding: "8px",
    color: "#6c757d",
    "&:hover": {
      backgroundColor: "#e9ecef",
    },
  },
  dialogContent: {
    padding: "0",
    backgroundColor: "#f5f5f5",
    minHeight: "400px",
  },
  headerSection: {
    display: "flex",
    alignItems: "center",
    padding: "20px 24px",
    backgroundColor: "white",
    borderBottom: "1px solid #e9ecef",
  },
  businessAvatar: {
    width: "56px",
    height: "40px",
    backgroundColor: "#8C1837",
    color: "white",
    fontSize: "18px",
    fontWeight: "bold",
    marginRight: "16px",
    borderRadius: "8px",
  },
  businessInfo: {
    flex: 1,
  },
  businessName: {
    fontSize: "18px",
    fontWeight: "600",
    color: "#2c3e50",
    marginBottom: "4px",
  },
  businessAddress: {
    fontSize: "14px",
    color: "#6c757d",
    lineHeight: "1.4",
  },
  arrowIcon: {
    color: "#6c757d",
    fontSize: "20px",
  },
  contactSection: {
    display: "flex",
    justifyContent: "space-around",
    padding: "16px 24px",
    backgroundColor: "white",
    borderBottom: "1px solid #e9ecef",
  },
  contactItem: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    cursor: "pointer",
    transition: "transform 0.2s ease",
    "&:hover": {
      transform: "translateY(-2px)",
    },
  },
  contactIcon: {
    width: "40px",
    height: "40px",
    borderRadius: "50%",
    backgroundColor: "#f8f9fa",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: "8px",
    color: "#6c757d",
    transition: "all 0.2s ease",
    "&:hover": {
      backgroundColor: "#e9ecef",
      color: "#495057",
    },
  },
  contactLabel: {
    fontSize: "12px",
    color: "#6c757d",
    fontWeight: "500",
  },
  summaryCard: {
    margin: "20px 24px",
    borderRadius: "12px",
    boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
    backgroundColor: "white",
  },
  summaryTitle: {
    fontSize: "16px",
    fontWeight: "600",
    color: "#2c3e50",
    marginBottom: "16px",
    paddingBottom: "8px",
    borderBottom: "2px solid #e9ecef",
  },
  appointmentDateTime: {
    fontSize: "16px",
    fontWeight: "500",
    color: "#495057",
    marginBottom: "8px",
    textAlign: "center",
    backgroundColor: "#f8f9fa",
    padding: "12px",
    borderRadius: "8px",
  },
  appointmentTime: {
    fontSize: "14px",
    color: "#6c757d",
    textAlign: "center",
    marginBottom: "16px",
  },
  professionalSection: {
    display: "flex",
    alignItems: "center",
    padding: "16px 0",
  },
  professionalAvatar: {
    width: "48px",
    height: "48px",
    marginRight: "16px",
    border: "2px solid #e9ecef",
  },
  professionalInfo: {
    flex: 1,
  },
  professionalName: {
    fontSize: "16px",
    fontWeight: "600",
    color: "#2c3e50",
    marginBottom: "4px",
  },
  serviceInfo: {
    fontSize: "14px",
    color: "#495057",
    marginBottom: "4px",
  },
  priceTag: {
    fontSize: "12px",
    color: "#6c757d",
    fontWeight: "500",
  },
  paymentInfo: {
    fontSize: "14px",
    color: "#495057",
    marginBottom: "8px",
    padding: "8px 12px",
    backgroundColor: "#f8f9fa",
    borderRadius: "6px",
  },
  balanceInfo: {
    fontSize: "14px",
    color: "#28a745",
    fontWeight: "500",
    textAlign: "center",
    padding: "8px",
    backgroundColor: "#d4edda",
    borderRadius: "6px",
  },
  actionButtons: {
    display: "flex",
    gap: "12px",
    padding: "20px 24px",
    backgroundColor: "white",
    borderTop: "1px solid #e9ecef",
    justifyContent: "center",
  },
  confirmButton: {
    backgroundColor: "#28a745",
    color: "white",
    padding: "12px 24px",
    borderRadius: "8px",
    fontWeight: "600",
    textTransform: "none",
    fontSize: "14px",
    "&:hover": {
      backgroundColor: "#218838",
    },
  },
  rescheduleButton: {
    backgroundColor: "transparent",
    color: "#495057",
    border: "2px solid #495057",
    padding: "12px 24px",
    borderRadius: "8px",
    fontWeight: "600",
    textTransform: "none",
    fontSize: "14px",
    "&:hover": {
      backgroundColor: "#495057",
      color: "white",
    },
  },
  cancelButton: {
    backgroundColor: "transparent",
    color: "#dc3545",
    border: "2px solid #dc3545",
    padding: "12px 24px",
    borderRadius: "8px",
    fontWeight: "600",
    textTransform: "none",
    fontSize: "14px",
    "&:hover": {
      backgroundColor: "#dc3545",
      color: "white",
    },
  },
}));

export default MuiStylesAppointmentDialog;


